<template>
<w-frame-popup-content-template>
  <div slot="content">
    <div class="title-bar title-h4">공지 등록</div>
    <el-form :rules="rules" ref="noticeForm" :model="noticeFormData" label-width="120px" label-position="left">
      <el-row>
        <el-form-item label="공지 기한" prop="noticeValidDate">
          <el-date-picker v-model="noticeFormData.noticeValidDate" type="date" format="yyyy-MM-dd" :clearable="false" @change="checkChangeInfo('noticeValidDate')" />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="제목" prop="noticeSubject">
          <el-input v-model="noticeFormData.noticeSubject" @blur="checkChangeInfo('noticeSubject')"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="내용" prop="noticeContents">
          <el-input type="textarea" :rows="5" v-model="noticeFormData.noticeContents" @blur="checkChangeInfo('noticeContents')"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="파일 등록">
          <el-upload :file-list="fileList" :auto-upload="false" :on-change="changeUploadFile" :show-file-list="false" :before-upload="(file) => file" action="">
            <el-button class="title-bar" type="secondary" size="mini">파일 업로드</el-button>
          </el-upload>
          <el-table :data="fileTableDatas" height="200px">
            <el-table-column prop="name" label="파일명" />
            <el-table-column label="삭제" width="60px">
              <template slot-scope="scope">
                <span class="c-pointer" @click="deleteFile(scope)"><i class="fal fa-times"></i></span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="공지 대상" prop="managerList">
          <el-row type="flex" justify="end" class="title-bar">
            <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
          </el-row>
          <el-table-wrapper :data="managerList" :columns="tableColumn" height="200px" header-align="center" ref="managerTable" :show-search-tool="showSearchTool" :show-custom-header="true" @selection-change="changeHandleSelection">
          </el-table-wrapper>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button v-if="viewType === 'ADD'" class="mr-r4" type="solid" size="large" @click="addNotice">저장</el-button>
    <el-button v-else type="solid" class="mr-r4" size="large" @click="updateNotice">저장</el-button>
    <el-button size="large" @click="cancelAddNotice">취소</el-button>
  </el-row>
</w-frame-popup-content-template>
</template>

<script>
import moment from 'moment';
import { map, forEach, findIndex, find, isNil } from 'lodash';
// import { isIE } from '@/utils/common';
import msgUtil from '@/utils/message';
import { checkFileSize, getFileNameExceptExtension, isUnauthorizedFile } from '@/utils/file';
import mgrApi from '@/api/model/mgr';
import userApi from '@/api/frame/user';
import { DUPLICATE_MESSAGE, MSG_UPLOAD_UNAUTHORIZED_FILE } from '@/constants/file';
import WFramePopupContentTemplate from './FramePopupContentTemplate';

export default {
  name: 'WNoticeForm',
  components: {
    WFramePopupContentTemplate,
  },
  props: {
    showAddView: {
      type: Boolean,
    },
    viewType: {
      type: String,
    },
    managerId: {
      type: String,
    },
  },
  data() {
    const dateValidation = (rule, value, callback) => {
      const today = new Date(moment().format('YYYY-MM-DD'));
      const tempValue = new Date(moment(value).format('YYYY-MM-DD'));
      if (tempValue < today) {
        return callback(new Error('공지 기한을 확인해주십시오.'));
      }
      return callback();
    };
    const managerListValidation = (rule, value, callback) => {
      if (this.selectedManager.length === 0) {
        return callback(new Error(' '));
      }
      return callback();
    };
    return {
      noticeFormData: {
        noticeValidDate: moment().format('YYYY-MM-DD'),
      },
      rules: {
        noticeSubject: [
          {
            required: true,
            message: '공지 제목을 입력해 주십시오.',
            trigger: 'blur',
          },
        ],
        noticeValidDate: [
          {
            required: true,
            validator: dateValidation,
            trigger: 'blur',
          },
        ],
        managerList: [
          {
            required: true,
            validator: managerListValidation,
            trigger: 'blur',
          },
        ],
      },
      showSearchTool: false,
      tableColumn: [
        {
          align: 'center',
          type: 'selection',
          width: '50px',
        },
        {
          prop: 'managerId',
          label: '아이디',
          searchable: true,
        },
        {
          prop: 'managerName',
          label: '계정명',
          searchable: true,
        },
        {
          prop: 'department',
          label: '부서',
          searchable: true,
        },
        {
          prop: 'association',
          label: '소속',
          searchable: true,
        },
        {
          prop: 'grade',
          label: '직급',
          searchable: true,
        },
      ],
      managerList: [],
      selectedManager: [],
      selectedManagerIds: [],
      fileList: [],
      fileTableDatas: [],
      addFiles: [],
      removeFiles: [],
      originFormData: {},
      checkChange: {
        noticeInfo: false,
        file: false,
        manager: false,
      },
    };
  },
  watch: {
    showAddView: {
      handler(val) {
        if (val) {
          this.loadManagerList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 관리자 목록 조회
     * @author kimjy
     */
    loadManagerList() {
      const params = {};
      mgrApi.getMgrList(params).then((response) => {
        if (response.data.success) {
          this.managerList = response.data.data;

          if (!isNil(this.selectedManagerIds)) {
            const managerTable = this.$refs.managerTable.$children[0];
            this.$nextTick(() => {
              forEach(this.selectedManagerIds, (item) => {
                managerTable.toggleRowSelection(find(this.managerList, ['managerId', item]));
                this.checkChange.manager = false;
              });
            });
          }
        }
      });
    },
    /**
     * form 데이터 초기화
     * @author kimjy
     * @param  {Object} formData 수정일 경우에만 존재
     */
    initFormData(formData) {
      if (isNil(formData)) {
        this.noticeFormData = {
          noticeValidDate: moment().format('YYYY-MM-DD'),
        };
        this.selectedManagerIds = [];
        this.selectedManager = [];
        this.fileTableDatas = [];
        this.addFiles = [];
        this.originFormData = {};
      } else {
        // 수정 시 데이터 설정
        this.originFormData = formData;
        this.noticeFormData = {
          noticeSubject: this.decodeHTMLStr(formData.noticeSubject),
          noticeContents: this.decodeHTMLStr(formData.noticeContents),
          noticeValidDate: formData.noticeValidDate,
          seqNumber: formData.seqNumber,
        };
        this.checkChange = {
          noticeInfo: false,
          file: false,
          manager: false,
        };

        forEach(formData.fileList, (file) => {
          this.fileTableDatas.push({
            name: `${file.attachFilename}.${file.attachFiletype}`,
          });
        });
        this.selectedManagerIds = formData.noticeTargets.split(', ');
      }
    },
    /**
     * 파일 추가될 경우  - 비인가 확장자 파일 업로드 불가능 기능 추가
     * @author kimjy -> NaJY
     */
    changeUploadFile(item) {
      // 비인가 확장자 파일인 경우 업로드 불가능
      if (isUnauthorizedFile(item)) {
        this.$message(msgUtil.getCustomResultMsgData(MSG_UPLOAD_UNAUTHORIZED_FILE, false));
        return;
      }
      if (findIndex(this.fileTableDatas, ['name', item.raw.name]) > -1) {
        this.$message(msgUtil.getCustomMsgData(DUPLICATE_MESSAGE));
        return;
      }
      const result = checkFileSize(item.raw.size);
      if (result.enable !== true) {
        this.$message(msgUtil.getCustomMsgData(result.message));
        return;
      }
      this.fileTableDatas.push(item.raw);
      if (this.viewType === 'UPDATE') {
        this.checkChange.file = true;
        this.addFiles.push(item.raw);
      }
    },
    /**
     * 공지사항 추가
     * @author kimjy
     */
    addNotice() {
      const managerIds = map(this.selectedManager, 'managerId');

      const params = new FormData();
      forEach(this.fileTableDatas, (value, index) => {
        params.append(`file${index}`, value);
      });
      if (managerIds.indexOf(this.managerId) < 0) {
        managerIds.push(this.managerId);
      }
      params.append('noticeInfo', JSON.stringify(this.noticeFormData));
      params.append('managerList', JSON.stringify(managerIds));

      this.$refs.noticeForm.validate((valid, object) => {
        if (valid) {
          const target = '공지사항';
          const action = msgUtil.action.REGIST;
          userApi
            .addNotice(params)
            .then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('load-data');
                this.$emit('update-count');
                this.cancelAddNotice();
              } else {
                this.$message(msgUtil.getCustomResultMsgData(response.data.message, false));
              }
            })
            .catch((e) => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
              throw new Error(e);
            });
        } else if (!isNil(object.managerList)) {
          this.$message(msgUtil.getCustomMsgData('공지 대상을 한 명 이상 선택해주십시오.'));
        } else {
          this.$message(msgUtil.getCustomMsgData('데이터를 확인해 주십시오.'));
        }
      });
    },
    /**
     * 관리자 선택
     * @author kimjy
     * @param  {[type]} selectVal [description]
     */
    changeHandleSelection(selectVal) {
      this.selectedManager = selectVal;
      this.checkChange.manager = true;
    },
    /**
     * 팝업 취소
     * @author kimjy
     */
    cancelAddNotice() {
      this.$emit('cancel');
    },
    /**
     * 파일 삭제
     * @author kimjy
     */
    deleteFile(data) {
      if (this.viewType === 'UPDATE') {
        this.checkChange.file = true;
        const tempData = this.fileTableDatas[data.$index];
        this.removeFiles.push(getFileNameExceptExtension(tempData.name));
        // 추가 후 삭제하는 파일의 경우 업로드 파일 배열(addFiles)에서 제거
        if (this.addFiles.includes(tempData)) {
          const removedFileIdx = this.addFiles.findIndex((file) => file.name === tempData.name);
          this.addFiles.splice(removedFileIdx, 1);
        }
      }
      this.fileTableDatas.splice(data.$index, 1);
    },
    /**
     * 수정 시 공지사항 정보 변경 확인
     * @author kimjy
     * @param  {String} key 변경된 formItem
     */
    checkChangeInfo(key) {
      if (!this.checkChange.noticeInfo && this.viewType === 'UPDATE') {
        this.checkChange.noticeInfo = this.originFormData[key] !== this.noticeFormData[key];
      }
    },
    /**
     * 공지사항 수정
     * @author kimjy
     */
    updateNotice() {
      let checkFlag = false;
      const updateCountFlag = false;

      const params = new FormData();
      params.append('seqNumber', this.noticeFormData.seqNumber);
      if (this.checkChange.file) {
        checkFlag = true;
        forEach(this.addFiles, (value, index) => {
          params.append(`file${index}`, value);
        });
        if (this.removeFiles.length > 0) {
          params.append('removeFiles', JSON.stringify(this.removeFiles));
        }
      }
      if (this.checkChange.noticeInfo) {
        checkFlag = true;
        params.append('noticeInfo', JSON.stringify(this.noticeFormData));
      }
      if (this.checkChange.manager) {
        checkFlag = true;
        const originManagerIds = this.originFormData.noticeTargets.split(', ');
        const managerIds = map(this.selectedManager, 'managerId');

        const removeManager = [];

        forEach(originManagerIds, (item) => {
          const index = managerIds.indexOf(item);
          if (index < 0) {
            removeManager.push(item);
          } else {
            managerIds.splice(index, 1);
          }
        });

        if (removeManager.indexOf(this.managerId) > -1) {
          removeManager.splice(removeManager.indexOf(this.managerId), 1);
        }

        params.append('removeManagerIds', JSON.stringify(removeManager));
        params.append('addManagerIds', JSON.stringify(managerIds));
      }

      const action = msgUtil.action.MODIFY;
      const target = '공지사항';

      if (!checkFlag) {
        this.$message(msgUtil.getCustomMsgData('변경사항이 없습니다.'));
        return;
      }

      this.$refs.noticeForm.validate((valid, object) => {
        if (valid) {
          userApi
            .updateNotice(params)
            .then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('load-data');
                if (updateCountFlag) {
                  this.$emit('update-count');
                }

                this.cancelAddNotice();
              } else {
                this.$message(msgUtil.getCustomResultMsgData(response.data.message, false));
              }
            })
            .catch((e) => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
              throw new Error(e);
            });
        } else if (!isNil(object.managerList)) {
          this.$message.error('공지 대상을 한 명 이상 선택해주십시오.');
        } else {
          this.$message.error('데이터를 확인해 주십시오.');
        }
      });
    },

    decodeHTMLStr(str) {
      return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/frame/components/popup/NoticeForm.vue